import { useMemo, useState } from 'react';
import Helmet from 'react-helmet';
import { withRouter } from 'react-router-dom';

import { FormBody, Row, HeaderSearch } from 'twyne-new.ui';

import { HeaderAddButton } from '@/components/Grid/components/header/Actions/AddButton'
import HeaderContainerGrid from '@/components/headerContainer/Grid';

import { useNavigationStore } from '../store';

import Card from './card';

function NavigationGrid({ location: { pathname } }) {
  const { collections: { items, useLoad } } = useNavigationStore()
  const [searchFocus, setSearchFocus] = useState(false)
  const [search, setSearch] = useState('')
  const normalizedSearch = search.trim().toLowerCase()

  const params = useMemo(() => {
    pathname; // keep to force load on route change
    return { autoRefresh: false }
  }, [pathname])

  const filteredItems = useMemo(() => items.filter(navigation => {
    if (!normalizedSearch) {
      return true
    }

    return (navigation.name || '').toLowerCase().includes(normalizedSearch)
  }), [items, normalizedSearch])

  useLoad(params)

  return <>
    <Helmet title="Navigation" />
    <HeaderContainerGrid title='Navigation' >
      <div className='flex items-center gap-2'>
        <HeaderSearch
          focused={searchFocus || !!search}
          onFocus={setSearchFocus}
          value={search}
          onChange={setSearch}
        />
        <HeaderAddButton to='/cms/settings/navigations/add'>
          Add Navigation
        </HeaderAddButton>
      </div>
    </HeaderContainerGrid>
    <FormBody>
      <Row>
        {filteredItems.map(navigation => <Card key={navigation.id} data={navigation} />)}
      </Row>
    </FormBody>
  </>
}

NavigationGrid.propTypes = {};
NavigationGrid.defaultProps = {};

export default withRouter(NavigationGrid)
